import classNames from 'classnames';
import * as React from 'react';
import { IconAi } from './icon_ai';
import { formatFishingReportsCount, PinProps } from './pin_low_activity';

export const PinHighActivity = (props: PinProps) => {
  const {
    fishingReportCount = 0,
    hasSummary,
    onClick,
    favorite,
    className,
    hasSurveyData,
    lunkerPotential,
  } = props;

  let fill = '#FF2A00';
  let icon = (
    <>
      <path
        d="M31.2661 27.0135C30.6592 27.6751 30.2951 27.9758 29.4454 27.9758C28.5957 27.9758 28.2923 27.615 27.6247 27.0135C27.0178 26.3519 26.2288 25.5701 24.833 25.5099C27.1392 21.8412 28.8992 19.255 28.8992 17.0898C28.9599 14.8645 26.8964 13 24.5902 13C22.284 13 20.2206 14.8645 20.2206 17.0898C20.2206 19.255 21.9806 21.8412 24.2868 25.5099C22.8909 25.5701 22.102 26.3519 21.4951 27.0135C20.8882 27.6751 20.524 27.9758 19.6744 27.9758C18.8247 27.9758 18.582 27.6751 17.9144 27.0135C17.3075 26.3519 16.5185 25.5701 15.062 25.5099C15.0013 25.5099 14.8799 25.6302 14.8799 25.6904V27.0737C14.8799 27.194 14.9406 27.2541 15.062 27.2541C15.7295 27.3142 16.0937 27.615 16.6399 28.2164C17.3075 28.878 18.0964 29.72 19.6744 29.72C21.2523 29.72 22.102 28.878 22.7088 28.2164C23.3157 27.5548 23.6799 27.2541 24.5295 27.2541C25.3792 27.2541 25.6826 27.615 26.3502 28.2164C27.0178 28.878 27.8068 29.72 29.3847 29.72C30.9626 29.72 31.8123 28.878 32.4799 28.2164C33.0261 27.615 33.3902 27.3142 34.0578 27.2541C34.1792 27.2541 34.2399 27.194 34.2399 27.0737V25.6904C34.2399 25.5701 34.1185 25.5099 34.0578 25.5099C32.6619 25.5701 31.873 26.4121 31.2661 27.0135ZM24.5902 14.7442C25.9861 14.7442 27.1999 15.8268 27.1999 17.0898C27.1999 18.4129 26.1075 20.2774 24.5902 22.6832C23.073 20.3376 21.9806 18.4129 21.9806 17.0898C21.9806 15.8869 23.2551 14.7442 24.5902 14.7442Z"
        fill="white"
      />
      <path
        d="M31.2149 32.1714C30.6099 32.8628 30.2469 33.1771 29.3999 33.1771C28.5529 33.1771 28.2504 32.8 27.5849 32.1714C26.9194 31.48 26.1329 30.6 24.5599 30.6C22.9869 30.6 22.1399 31.48 21.5349 32.1714C20.9299 32.8628 20.5669 33.1771 19.7199 33.1771C18.8729 33.1771 18.5704 32.8 17.9049 32.1714C17.2999 31.48 16.5134 30.6628 15.0614 30.6C14.9404 30.6 14.8799 30.6628 14.8799 30.7885V32.2343C14.8799 32.36 14.9404 32.4228 15.0614 32.4228C15.7269 32.4857 16.0899 32.8 16.6344 33.4285C17.2999 34.12 18.1469 35 19.7199 35C21.2929 35 22.1399 34.12 22.7449 33.4285C23.3499 32.7371 23.7129 32.4228 24.5599 32.4228C25.4069 32.4228 25.7094 32.8 26.3749 33.4285C27.0404 34.12 27.8269 35 29.3999 35C30.9729 35 31.8199 34.12 32.4854 33.4285C33.0299 32.8 33.3929 32.4857 34.0584 32.4228C34.1794 32.4228 34.2399 32.36 34.2399 32.2343V30.7885C34.2399 30.6628 34.1189 30.6 34.0584 30.6C32.6064 30.6628 31.8199 31.48 31.2149 32.1714Z"
        fill="white"
      />
    </>
  );
  if (hasSurveyData) {
    fill = '#00CC00';
    icon = (
      <>
        <g clip-path="url(#clip0_379_19596)">
          <path
            d="M19.9811 25.4003C18.8771 25.7368 15.3907 23.8933 15.2164 23.0007C15.1438 22.5325 15.2309 20.5719 15.2309 20.5719L19.9956 20.8792V25.3857L19.9811 25.4003Z"
            fill="white"
          />
          <path
            d="M33.5779 26.4099C30.8323 24.2298 26.9973 23.9079 23.816 25.3272C22.6539 25.8393 20.5621 27.639 19.5162 27.6828C18.078 27.7414 16.669 26.2929 15.2744 26.0002V32.043C16.7561 31.926 18.4703 29.819 19.9229 29.9361C20.7073 30.0093 22.9735 31.8967 24.1647 32.3503C25.0508 32.6868 25.7045 32.8039 26.6487 32.877C27.2588 32.9209 28.1014 32.9209 28.7115 32.877C30.5999 32.7453 32.1978 32.0869 33.6795 30.9018C36.1055 28.9412 35.9747 28.3413 33.5633 26.4245L33.5779 26.4099ZM31.1665 29.8483C30.3239 29.8483 29.6557 29.1606 29.6557 28.3266C29.6557 27.4926 30.3384 26.805 31.1665 26.805C31.9945 26.805 32.6772 27.4926 32.6772 28.3266C32.6772 29.1606 31.9945 29.8483 31.1665 29.8483Z"
            fill="white"
          />
          <path
            d="M26.3725 16.8994L21.7676 17.3676V23.7616C22.4067 23.2787 23.8449 22.196 26.387 22.0351V16.8994H26.3725Z"
            fill="white"
          />
          <path
            d="M32.8516 23.0154V12.6562H28.0869V21.9619C28.697 21.9619 30.2223 22.0789 32.8516 23.03V23.0154Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_379_19596">
            <rect
              width="20.25"
              height="20.25"
              fill="white"
              transform="translate(15.1875 12.6562)"
            />
          </clipPath>
        </defs>
      </>
    );
  }
  if (lunkerPotential) {
    fill = '#8800FF';
    icon = (
      <>
        <g clip-path="url(#clip0_379_19477)">
          <path
            d="M31.4978 20.3034L28.6419 22.1581L25.9173 17.4639C25.6054 17.8085 25.1459 18.0055 24.6699 18.0219C24.2924 18.0219 23.9313 17.907 23.6358 17.6772L21.0753 22.1253L18.3671 20.3198C18.1209 20.9763 17.4808 21.4031 16.7586 21.4195C16.5781 21.4195 16.3975 21.3867 16.2334 21.3374L16.4468 30.611C16.4468 30.9721 16.7586 31.2511 17.1197 31.2511H32.7288C33.1063 31.2675 33.4018 30.9885 33.4018 30.6274L33.6152 21.2389C33.4346 21.3046 33.2377 21.3374 33.0571 21.3374C32.3677 21.3374 31.7604 20.9271 31.4978 20.3198V20.3034ZM31.941 29.7903H27.0334L31.941 25.1453V29.7903Z"
            fill="white"
          />
          <path
            d="M17.7266 17.4639C17.7266 16.2493 16.6926 15.248 15.4287 15.248C14.1649 15.248 13.1309 16.2493 13.1309 17.4639C13.1309 18.6784 14.1649 19.6797 15.4287 19.6797C16.6926 19.6797 17.7266 18.6784 17.7266 17.4639Z"
            fill="white"
          />
          <path
            d="M24.7354 15.921C25.9992 15.921 27.0332 14.9198 27.0332 13.7052C27.0332 12.4906 25.9992 11.4894 24.7354 11.4894C23.4715 11.4894 22.4375 12.4906 22.4375 13.7052C22.4375 14.9198 23.4715 15.921 24.7354 15.921Z"
            fill="white"
          />
          <path
            d="M34.2383 15.248C32.9745 15.248 31.9404 16.2493 31.9404 17.4639C31.9404 18.6784 32.9745 19.6797 34.2383 19.6797C35.5021 19.6797 36.5362 18.6784 36.5362 17.4639C36.5362 16.2493 35.5021 15.248 34.2383 15.248Z"
            fill="white"
          />
          <path
            d="M32.1209 32.9909H17.6935C16.9955 32.9909 16.4297 33.5567 16.4297 34.2547C16.4297 34.9527 16.9955 35.5186 17.6935 35.5186H32.1209C32.8189 35.5186 33.3847 34.9527 33.3847 34.2547C33.3847 33.5567 32.8189 32.9909 32.1209 32.9909Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_379_19477">
            <rect
              width="23.4055"
              height="24.0292"
              fill="white"
              transform="translate(13.1309 11.4894)"
            />
          </clipPath>
        </defs>
      </>
    );
  }
  if (favorite) {
    fill = '#FF8022';
    icon = (
      <>
        <g clip-path="url(#clip0_379_19528)">
          <path
            d="M26.071 16.8022L27.5558 20.2419C27.9269 21.1019 28.7436 21.6949 29.6939 21.7839L33.4207 22.1397C34.5491 22.2435 34.9946 23.6372 34.1482 24.3933L31.342 26.8693C30.6293 27.492 30.3175 28.4557 30.5253 29.3749L31.342 33.0222C31.5944 34.1193 30.4066 34.9793 29.4266 34.4159L26.2046 32.5033C25.388 32.0288 24.3783 32.0288 23.5765 32.5033L20.3545 34.4159C19.3894 34.9941 18.2016 34.1342 18.4391 33.0222L19.2558 29.3749C19.4636 28.4557 19.1518 27.492 18.4391 26.8693L15.6329 24.3933C14.7865 23.652 15.2468 22.2583 16.3604 22.1397L20.0872 21.7839C21.0227 21.6949 21.8393 21.1019 22.2253 20.2419L23.7101 16.8022C24.1556 15.7644 25.6255 15.7644 26.071 16.8022Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_379_19528">
            <rect
              width="19.4062"
              height="18.5625"
              fill="white"
              transform="translate(15.1875 16.0312)"
            />
          </clipPath>
        </defs>
      </>
    );
  }

  return (
    <div className={classNames('relative', className)} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="54"
        viewBox="0 0 50 54"
        fill="none"
      >
        <g opacity="0.25">
          <path
            d="M23.8981 51.8335C22.9954 51.3903 1.6416 40.7052 1.6416 24.817C1.6416 12.0474 11.9492 1.64136 24.6203 1.64136C37.2914 1.64136 47.599 12.0474 47.599 24.817C47.599 40.9514 26.2452 51.3903 25.3261 51.8335L24.6039 52.1781L23.8817 51.8335H23.8981Z"
            fill="white"
          />
          <path
            d="M24.6201 3.28267C36.4049 3.28267 45.9574 12.9337 45.9574 24.817C45.9574 40.0979 24.6201 50.3562 24.6201 50.3562C24.6201 50.3562 3.28267 39.8681 3.28267 24.817C3.28267 12.9337 12.8353 3.28267 24.6201 3.28267ZM24.6201 0C11.0462 0 0 11.1283 0 24.817C0 41.7064 22.2237 52.8346 23.1757 53.2942L24.6036 54L26.048 53.3106C27 52.8511 49.2401 41.969 49.2401 24.817C49.2401 11.1283 38.1939 0 24.6201 0Z"
            fill="black"
          />
        </g>
        <path
          d="M24.6199 48.5179C20.9925 46.5647 4.92383 37.1763 4.92383 24.8334C4.92383 13.8693 13.7542 4.94043 24.6199 4.94043C35.4855 4.94043 44.3159 13.8693 44.3159 24.8334C44.3159 37.3897 28.2472 46.5976 24.6199 48.5179Z"
          fill={fill}
        />
        <path
          d="M24.6196 6.56527C34.5825 6.56527 42.6743 14.7555 42.6743 24.8169C42.6743 35.7318 29.1333 44.1355 24.636 46.6303C22.7649 45.5799 19.3509 43.4954 15.9698 40.623C11.6859 36.9792 6.5649 31.2838 6.5649 24.8005C6.5649 14.7391 14.6567 6.54885 24.6196 6.54885M24.6196 3.28259C12.8348 3.28259 3.28223 12.9337 3.28223 24.8169C3.28223 39.868 24.6196 50.3561 24.6196 50.3561C24.6196 50.3561 45.957 40.0978 45.957 24.8169C45.957 12.9172 36.4044 3.28259 24.6196 3.28259Z"
          fill="white"
        />
        {icon}
      </svg>
      {fishingReportCount > 0 && (
        <div
          className={
            'absolute top-1 left-[calc(100%-15px)] bg-[#002b3a] rounded-full text-white border-white border-2 text-[10px] leading-tight font-medium px-[3px]'
          }
        >
          {formatFishingReportsCount(fishingReportCount)}
        </div>
      )}
      {hasSummary && (
        <div className="-bottom-2 -left-3 absolute">
          <IconAi />
        </div>
      )}
    </div>
  );
};

PinHighActivity.width = 50;
PinHighActivity.height = 54;
